'use strict';

var GridBookingMatrixSwitchButtonDirective = function GridBookingMatrixSwitchButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-booking-matrix-switch-view-button.html')
  };
};
GridBookingMatrixSwitchButtonDirective.$inject = [];
module.exports = GridBookingMatrixSwitchButtonDirective;